/**
 * Base class for selectable options used in dropdowns and select controls.
 * Subclasses (e.g., FrequencyOption, ReferenceOption) extend this to add
 * domain-specific behavior while inheriting a common value/display contract.
 *
 * Uses a generic type parameter so subclasses can narrow the value type
 * (e.g., number for occurrence counts, string for IDs).
 */
class Option<T = string> {
  value: T;

  constructor(value: T) {
    this.value = value;
  }

  getValue(): T {
    return this.value;
  }

  getDisplayValue(): string {
    return String(this.value);
  }
}

export default Option;
